import { DialogProps, Root } from '@radix-ui/react-dialog';

export const GalleryDialog = ({ children, ...props }: DialogProps) => {
	return <Root {...props}>{children}</Root>;
};
